// extracted by mini-css-extract-plugin
export default {"midWrapper":"FeedMidBox_midWrapper__X6ouD","midTitle":"FeedMidBox_midTitle__ElWxS","midText":"FeedMidBox_midText__WkSQK","midButton":"FeedMidBox_midButton__YKYk3"};